import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { useEvent } from '../../hooks';
import { styled } from '@mui/material/styles';
import { EventLogTable } from './EventLogTable';

export interface EventLogCardProps {
  title: string;
  scrollHeight?: number;
}

const FormWrapper = styled('div')(() => ({
  margin: 'auto',
  padding: '1rem',
  overflow: 'inherit',
}));
const StyledHeader = styled(CardHeader)(({ theme }) => ({
  borderBottomColor: theme.palette.divider,
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  padding: 11,
  paddingTop: 8,
  paddingBottom: 8,
  color: '#000000',
}));
const CardOuter = styled(CardContent)(() => ({
  paddingBottom: '22px !important',
  paddingTop: '5px',
  paddingRight: '1px',
  minHeight: '212px',
}));

export const EventLogCard = ({ title, scrollHeight }: EventLogCardProps) => {
  const { eventLogProps } = useEvent();

  const style: React.CSSProperties = {};
  if (scrollHeight) {
    style.maxHeight = scrollHeight;
    style.overflow = 'auto';
  }
  return (
    <FormWrapper>
      <Card>
        <StyledHeader title={title} disableTypography />
        <CardOuter>
          <div style={style}>
            {eventLogProps?.length ? (
              <EventLogTable items={eventLogProps} />
            ) : (
              <span>There are no events here</span>
            )}
          </div>
        </CardOuter>
      </Card>
    </FormWrapper>
  );
};
